(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.headerBounds = { top: 0, bottom: 0 };
        this.isScrolling = null;
        this.resizeObserver = null;
        this.intersectionObserver = null;
      }

      connectedCallback() {
        if (this.dataset.whlInitialized === 'true') return;
        this.dataset.whlInitialized = 'true';

        this.header = this.closest('.shopify-section') || document.querySelector('.section-header');
        if (!this.header) return;

        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';

        this.predictiveSearch = this.querySelector('predictive-search');
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => {
          this.preventReveal = true;
        };

        this.setHeaderHeight();
        this.setInitialBounds();

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });

        this.resizeObserver = new ResizeObserver(() => {
          this.setHeaderHeight();
          this.setInitialBounds();
        });
        this.resizeObserver.observe(this.header);

        this.createObserver();
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        window.clearTimeout(this.isScrolling);
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }

      setHeaderHeight() {
        if (!this.header) return;
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      setInitialBounds() {
        if (!this.header) return;

        const rect = this.header.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        this.headerBounds = {
          top: rect.top + scrollTop,
          bottom: rect.bottom + scrollTop
        };
      }

      createObserver() {
        this.intersectionObserver?.disconnect();

        this.intersectionObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry) return;

          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          this.headerBounds = {
            top: entry.boundingClientRect.top + scrollTop,
            bottom: entry.boundingClientRect.bottom + scrollTop
          };

          this.intersectionObserver?.disconnect();
        });

        this.intersectionObserver.observe(this.header);
      }

      hasOpenInteractiveContent() {
        if (this.predictiveSearch?.isOpen) return true;
        return Boolean(this.querySelector('details[open]'));
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.hasOpenInteractiveContent()) {
          this.currentScrollTop = scrollTop;
          return;
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');

          if (!this.preventHide) {
            requestAnimationFrame(() => this.hide());
          }
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');

          if (!this.preventReveal) {
            requestAnimationFrame(() => this.reveal());
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = window.setTimeout(() => {
              this.preventReveal = false;
            }, 80);

            requestAnimationFrame(() => this.hide());
          }
        } else if (scrollTop <= Math.max(this.headerBounds.top, 0)) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(() => this.reset());
        }

        this.currentScrollTop = Math.max(scrollTop, 0);
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;

        this.header.classList.add(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky'
        );

        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;

        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;

        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
      }

      closeMenuDisclosure() {
        const disclosures = this.querySelectorAll('header-menu');

        disclosures.forEach((disclosure) => {
          if (typeof disclosure.close === 'function') disclosure.close();
        });
      }

      closeSearchModal() {
        const searchModal = this.querySelector('details-modal');

        if (searchModal && typeof searchModal.close === 'function') {
          searchModal.close(false);
        }
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  /* ============================================================
     WHITEHOUSE SHOWROOM LIGHT TOGGLE
     DESIGNED & POWERED BY H@Z0 T3C#
     ============================================================ */

  (() => {
    const STORAGE_KEY = 'whl-showroom-lights-off';

    function setLightsState(isOff) {
      document.documentElement.classList.toggle('whl-showroom-lights-off', isOff);

      document.querySelectorAll('[data-whl-light-toggle]').forEach((button) => {
        const actionText = isOff ? 'Switch on the lights' : 'Switch off the lights';

        button.setAttribute('aria-pressed', isOff ? 'true' : 'false');
        button.setAttribute('aria-label', actionText);
        button.setAttribute('title', actionText);

        const tooltip = button.querySelector('[data-whl-light-tooltip]');
        if (tooltip) tooltip.textContent = actionText;

        const hiddenText = button.querySelector('[data-whl-light-toggle-hidden]');
        if (hiddenText) hiddenText.textContent = actionText;
      });

      try {
        sessionStorage.setItem(STORAGE_KEY, isOff ? '1' : '0');
      } catch (error) {
        // Storage may be unavailable in some privacy modes.
      }
    }

    function getStoredState() {
      try {
        return sessionStorage.getItem(STORAGE_KEY) === '1';
      } catch (error) {
        return false;
      }
    }

    function triggerWhitehouseElectricFlash(button) {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const root = document.documentElement;

      root.classList.remove('whl-electric-shock');
      if (button) button.classList.remove('whl-light-toggle--spark');

      void document.body.offsetWidth;

      root.classList.add('whl-electric-shock');
      if (button) button.classList.add('whl-light-toggle--spark');

      window.setTimeout(() => {
        root.classList.remove('whl-electric-shock');
        if (button) button.classList.remove('whl-light-toggle--spark');
      }, 620);
    }

    function initialiseWhitehouseLightToggle() {
      setLightsState(getStoredState());

      document.querySelectorAll('[data-whl-light-toggle]').forEach((button) => {
        if (button.dataset.whlLightInitialised === 'true') return;

        button.dataset.whlLightInitialised = 'true';

        button.addEventListener('click', () => {
          const nextState =
            !document.documentElement.classList.contains('whl-showroom-lights-off');

          setLightsState(nextState);
          triggerWhitehouseElectricFlash(button);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseWhitehouseLightToggle, { once: true });
    } else {
      initialiseWhitehouseLightToggle();
    }

    document.addEventListener('shopify:section:load', initialiseWhitehouseLightToggle);
  })();


  } catch(e) { console.error(e); }
})();
})();
